import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { Field, reduxForm, propTypes as formProps } from 'redux-form';

import { MinimalFooter } from '@zola/zola-ui';
import { sendResetPassword } from '@zola-helpers/client';
import { RenderField, RenderSubmitButton } from '../../components/common/form';
import * as Validations from '../../components/common/form/commonValidations';

import '../../stylesheets/pages/preauth/SignupPageContainer.less';

class ForgotPasswordFullPage extends Component {
  constructor(props) {
    super(props);

    this.handleError = this.handleError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      error: false,
      errorMessage: '',
      showSuccess: false
    };
  }

  onSubmit(values) {
    const { handleSubmit } = this.props;
    handleSubmit(values)
      .then((response) => {
        if (response.success) {
          this.setState({ showSuccess: true });
        } else {
          throw Error('Email not found');
        }
      })
      .catch(this.handleError);
  }

  handleError(error) {
    this.setState({ error: true, errorMessage: error.detailedMessage });
  }

  render() {
    const { pristine, valid } = this.props;
    const { error, errorMessage, showSuccess } = this.state;

    return (
      <div className="full-page-signup">
        <Helmet
          style={[
            {
              type: 'text/css',
              cssText: ` html, .main-content {
                background: #FCFCFC;
              }
              body {
                margin-bottom: 75px;
              }`
            }
          ]}
        />
        <header className="minimal-header">
          <a href="/" target="_self">
            <div className="zola-logo-horizontal-black center-block" />
          </a>
        </header>
        { showSuccess
          ? (
            <div>
              <div className="text-h1 intent-title col-xs-12 text-center forgot zui__h1">
              Thanks!
              </div>
              <div className="text-center">
              We&#39;ve emailed you a link to change your password.
                <br />
                <br />
              If you are still unable to log in, please contact <a href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer">customer support</a> for assistance.
              </div>
              <br />
              <p className="text-center signup-footer">
                <Link to="/onboard/login">Log In</Link>
              </p>
            </div>
          ) : (
            <div>
              <h1 className="text-h1 intent-title col-xs-12 text-center forgot zui__h1">
              Forgot Password
              </h1>
              <p className="text-center forgot col-xs-12 col-sm-6 col-sm-offset-3">
                Enter your email address and we&#39;ll send you a link to change your password.
              </p>
              <div className="signup-body">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                      <form onSubmit={this.onSubmit}>
                        <Field
                          name="email"
                          type="email"
                          placeholder="Email"
                          id="login-email"
                          component={RenderField}
                          required
                          validate={[Validations.REQUIRED, Validations.EMAIL]}
                        />
                        <RenderSubmitButton
                          value="Submit"
                          valid={valid}
                          disableWhenPristine
                          pristine={pristine}
                        />
                      </form>
                    </div>
                  </div>
                </div>
                <p className="text-center signup-footer">
                  <Link to="/onboard/login">Log In</Link> / <Link role="button" to="/onboard/select-product">Sign Up</Link>
                </p>
                { error && (
                  errorMessage ? <div className="form-message-block text-center text-danger">{ errorMessage }</div>
                    : <div className="form-message-block text-center text-danger">There was a problem processing your request. <br />Please try again or contact <a href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer">customer support</a> for assistance.</div>) }
              </div>
            </div>
          ) }
        <MinimalFooter />
      </div>
    );
  }
}

ForgotPasswordFullPage.propTypes = {
  // onSuccess: PropTypes.func.isRequired,
  location: PropTypes.shape({}),
  handleSubmit: PropTypes.func.isRequired,
  ...formProps,
};

const mapDispatchToProps = dispatch => (
  {
    onSubmit: ({ email }) => dispatch(sendResetPassword(email))
  }
);

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'ForgotPasswordForm'
})(ForgotPasswordFullPage));



// WEBPACK FOOTER //
// ./src/pages/preauth/ForgotPasswordPage.jsx